import IScoreComponent, { Result } from '@components/FormFlow/Interfaces/FormflowComponents/IScoreComponent';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import { InputNumber } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

import ProcessContext from '../ProcessContext';

interface IScoreTaskComponentStateType {
  results: Result[];
};

export class ScoreComponent implements IScoreComponent {
  id: string;
  type: ComponentType;
  title: string;
  description?: string;
  results: Result[];


  constructor(id: string = '') {
    this.id = id;
    this.type = ComponentType.SCORE;
    this.title = '';
    this.results = [{
      label: '',
      min: undefined,
      max: undefined
    }]
    return this;
  }
}

export default class ScoreComponentProcess extends React.Component<IScoreComponent, IScoreTaskComponentStateType> {

  constructor(props: IScoreComponent) {
    super(props);
    this.state = {
      results: this.props.results || [{
        label: '{{value}}',
        min: 0,
        max: 1
      }]
    };
  }

  //#region HANDLERS
  handleAddNewScore = async () => {
    this.setState({
      results: this.state.results.concat([{ operator: '', label: '{{value}}', min: undefined, max: undefined }]),
    });
  }
  handleInputMinScoreChange = (idx: any) => async (evt: any) => {
    const newScore = this.state.results.map((score, sidx) => {
      if (idx !== sidx) return score;
      return { ...score, min: evt };
    });
    this.setState({ results: newScore });
  }

  handleInputMaxScoreChange = (idx: any) => async (evt: any) => {
    const newScore = this.state.results.map((score, sidx) => {
      if (idx !== sidx) return score;
      return { ...score, max: evt };
    });
    this.setState({ results: newScore });
  }
  handleInputLabelChange = (idx: any) => async (evt: any) => {
    const newScore = this.state.results.map((score, sidx) => {
      if (idx !== sidx) return score;
      return { ...score, label: evt.target.value };
    });
    this.setState({ results: newScore });
  }
  handleRemoveScore = (index: number) => async () => {
    this.setState({
      results: this.state.results.filter((section: any, sindex: number) => index !== sindex),
    });
  }

  //#endregion

  onSave(updateFormflowWithComponent: (component: any) => void) {
    const newScoreComponent: any = {
      results: this.state.results
    }

    updateFormflowWithComponent(newScoreComponent);
  }

  render() {
    return (
      <div>
        {this.state.results.map((resultItems, idx: number) => (
          <div key={idx} style={{marginBottom: '2.5rem'}}>
            <div style={{ marginBottom: '10px' }}><span>{I18n.l("label.components.score.sumCompare")}</span></div>
            <div style={{ marginBottom: '10px' }}>
              <InputNumber
                placeholder='0'
                value={resultItems.min}
                style={{ width: '50px', marginRight: '10px' }}
                onChange={this.handleInputMinScoreChange(idx)}
              />
              <span>{I18n.l("form.taskflowschedule.labels.and")}</span>
              <InputNumber
                placeholder='0'
                value={resultItems.max}
                style={{ width: '50px', marginLeft: '10px', marginRight: '10px' }}
                onChange={this.handleInputMaxScoreChange(idx)}
              />
              <span>{I18n.l("label.components.score.showMessage")}</span>
            </div>
            <TextArea
              value={resultItems.label}
              rows={4}
              onChange={this.handleInputLabelChange(idx)}
            />
            <div
              style={{ float: 'right', color: '#335D7C', marginTop: '10px', cursor: 'pointer' }}
              onClick={this.handleRemoveScore(idx)}
            >
             <span>{I18n.l("formflow.components.calculatorComponent.deleteMessage")}</span>
            </div>
          </div>

        ))}
        <div  onClick={this.handleAddNewScore} >
          <Icon color=' #1890ff' size='2x' icon={faPlusCircle} />
        </div>

        <ProcessContext.Consumer>
          {({ updateProcessComponent }) => (
            <>
              {this.onSave(updateProcessComponent)}
            </>
          )}
        </ProcessContext.Consumer>
      </div>
    );
  }
}

//#region CSS

//#endregion
